import { useContext } from 'react';

import { AddToCTCartDrawerProviderContext } from '@app/pdp/providers/AddToCTCartProvider';

export const useAddToCTCartDrawer = () => {
    const context = useContext(AddToCTCartDrawerProviderContext);

    if (context === undefined || context === null) {
        throw new Error(
            'useAddToCTCartDrawer must be used within a AddToCTCartDrawerContext'
        );
    }

    return context;
};
